import React from 'react';
import CardButton from '../CardButton/CardButton';
import './MilestoneSlide.css';
import { cosmosTrackService } from '../../../../../cosmosTracking/cosmosTrackService';
import {view_all_milestone} from '../../../../../cosmosTracking/cosmosEvents';
import ProgressMeter from "../../../../web/components/progressMeter/progressMeter";

function MilestoneSlide(props) {
	const { data, } = props;
	return (
		<>
		<div className="slideCard slideCardMileStone">
			<div className="cardHeader">
				<img src="https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/birthday-sale-slide-home-header-title.png" alt="title"/>
			</div>
			<div className="cardBody">
				<img className="mile-stone-top-img" src="https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/birthday-sale-mile-stone-top-img.png" alt="top img"/>
				<div className="mileStoneData">
					<h4>Wing amazing </h4>
					<h2>Surprise Gift</h2>
					{/*<img src={data?.peakDay?.mileStones?.mileStoneData?.imgUrl} alt="img" />*/}
				</div>
				<CardButton text={'View All Milestones'} className={'btn-action'} eventCallback={() => {cosmosTrackService(view_all_milestone);}} deeplink={data?.deeplink}
				/>
			</div>
		</div>
		</>
	);
}

export default MilestoneSlide;

